import styled, { css } from "styled-components";

export default styled.div<{ collapsed: boolean }>`
  overflow: hidden;
  max-height: 5000px;
  transition: max-height 0.5s cubic-bezier(1, 0, 1, 0);

  ${(props) =>
    props.collapsed &&
    css`
      max-height: 0;
      transition: max-height 0.85s cubic-bezier(0, 1, 0, 1);
    `}
`;
